wbApp.controller('ScheduleCourseDetailCtrl', ['$scope', '$translate', '$filter', 'courseScheduleSvc', 'courseSvc', 'messageBoxSvc',
    'tenantInfo', 'attendanceSvc', 'courseRegistrationSvc',
function ($scope, $translate, $filter, courseScheduleSvc, courseSvc, messageBoxSvc, tenantInfo, attendanceSvc, courseRegistrationSvc) {
    $scope.modelOrig = angular.copy($scope.model);

    $scope.attendanceChanged = false;

    function loadData() {
        // $scope.editRecurrence
        if ($scope.model.courseScheduleID && !$scope.editRecurrence) {
            $scope.lessonAttendance = attendanceSvc.getLessonAttendance($scope.model.courseScheduleID);
        } else {
            $scope.lessonAttendance = courseRegistrationSvc.getRegisteredAttendanceForCourse($scope.model.courseID);
        }
    }

    loadData();

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig) && !!$scope.model.courseScheduleID;
    };
    
    function wasModelChangedApartFromTeacherIds(model) {
        let origCopy = angular.copy($scope.modelOrig);
        origCopy.teacherIds = null;
        
        let modelCopy = angular.copy(model);
        modelCopy.teacherIds = null;
        
        return !angular.equals(origCopy, modelCopy);
    }

    $scope.onStartDateChanged = function (startDate) {
        if (!!$scope.editRecurrence) {
            courseScheduleSvc.updateEventByStartDate($scope.model, startDate);
        }
    }

    var selectedCourse = null;

    $scope.onCourseChange = function (courseID) {
        var cID = courseID;

        if (typeof courseID === 'string' || courseID instanceof String) {
            cID = parseInt(courseID);
        }

        if (!!cID) {
            courseSvc.getCourseAsync($scope.model.semesterID, cID).then(function (course) {
                $scope.model.employeeID = course.employeeID;
                $scope.model.teacherIds = course.teacherIds;
                selectedCourse = course;
                $scope.model.capacity = course.capacity;

                $scope.lessonAttendance = courseRegistrationSvc.getRegisteredAttendanceForCourse(selectedCourse.courseID);
            }, function (reason) {
                alert(reason);
            });
        }
    }

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;


        function success() {
            $scope.$hide();
            if ($scope.onSave) {
                $scope.onSave();
            }
        }

        function error(data) {
            $scope.detailError = data;
            $scope.isSaving = false;
        }

        if (!data.courseScheduleID) {
            courseScheduleSvc.insert(data, success, error);
        } else {
            if (!$scope.editRecurrence && wasModelChangedApartFromTeacherIds(data)) {
                messageBoxSvc.showConfirmClientNotification({
                    userSetting: ['ConfirmNotificationSchedule', 'ConfirmNotificationSmsSchedule'],
                    showSendSmsNotification: true,
                    callback: function (notificationConfig) {
                        courseScheduleSvc.update(data, notificationConfig, success, error);
                    }
                });
            } else {
                // We are changing the series, so do not ask for notifications, there are no emails send anyways
                var notificationConfig = {
                    sendEmailNotification: false,
                    sendSmsNotification: false
                };
                courseScheduleSvc.update(data, notificationConfig, success, error);
            }
        }
    }

    $scope.onDetailCancel = function () {
        if ($scope.attendanceChanged && $scope.onSave) {
            $scope.onSave();
        }
        $scope.$hide();
    }

    $scope.$watch('model', function (model) {
        var diff = moment.duration(moment(model.endDate).diff(moment(model.startDate)));

        var fdays = diff.days() ? diff.days() + 'd ' : '';
        var fhours = diff.hours() ? diff.hours() + 'h ' : '';
        var fminutes = diff.minutes() ? diff.minutes() + 'm ' : '';
        var fmonths = diff.months() ? diff.months() + 'm ' : '';
        var fyears = diff.years() ? diff.years() + 'r ' : '';

        $scope.lessonLength = fyears + fmonths + fdays + fhours + fminutes;
    }, true);

    $scope.detailTabs = [
    {
        title: 'TXT_MAIN',
        template: "schedule/schedule/schedule-course-detail-main-tab.html"
    }];

    if (!!$scope.editRecurrence) {
        $scope.detailTabs.push({
            title: 'TXT_LBL_RECURRENCE',
            template: "schedule/schedule/schedule-course-detail-recurrence-tab.html"
        });
    }

    $scope.detailTabs.push({
        title: 'TXT_LBL_STUDENTS',
        template: 'schedule/schedule/schedule-course-detail-students-tab.html'
    });

    if ($scope.model.courseScheduleID && !$scope.editRecurrence) {
        $scope.detailTabs.push({
            title: 'TXT_LBL_WAIT_QUEUE',
            template: 'schedule/schedule/schedule-course-detail-wait-queue-tab.html'
        });
    }


    $scope.detailTabs.activeTab = 0;

    $scope.$watch('detailTabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });

    $scope.studentsGridSettings = {
        name: 'students',
        columns: [
            { dataField: 'fullName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string' },
            {
                dataField: 'attendanceStatus',
                caption: $translate.instant('TXT_COL_ATTENDANCE_STATUS'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('attendanceStatus')(rowData.attendanceStatus);
                },
                width: '100px'
            },
            {
                dataField: 'attendanceType',
                caption: $translate.instant('TXT_COL_ATTENDANCE_TYPE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('attendanceType')(rowData.attendanceType);
                },
                width: '100px'
            },
            { dataField: 'attendanceCount', caption: $translate.instant('TXT_LBL_COUNT'), dataType: 'number', width: '50px' },
            {
                dataField: 'updatedAt',
                caption: $translate.instant('TXT_LBL_UPDATED_AT'),
                dataType: 'date',
                format: 'shortDateShortTime',
                width: '130px',
                visible: !$scope.editRecurrence
            },
            { dataField: 'updatedBy', caption: $translate.instant('TXT_LBL_UPDATED_BY'), dataType: 'string', width: '80px', visible: !$scope.editRecurrence },
        ],
        shouldDisableDelete: function (row) {
            return row.attendanceType === 0;
        }
    }

    $scope.onRowDelete = function (data) {
        attendanceSvc.remove(data, null, function () {
            $scope.attendanceChanged = true;
            loadData();
        });
        
    }


    $scope.waitQeueuGridSettings = {
        name: 'waitQueue',
        columns: [
            { dataField: 'studentFullName', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string' },
            { dataField: 'email', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '190px' },
            {
                dataField: 'phone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.phone);
                },
                width: '130px'
            },
            { dataField: 'createdAt', caption: $translate.instant('TXT_LBL_CREATED_AT'), dataType: 'date', format: 'shortDateShortTime',  width: '130px', sortOrder: 'asc' },
        ]
    }

}]);
